import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAffiliateUserData } from '../affiliateService'

export const useAffiliateUserData = (affId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AFFILIATE_USER, affId],
    queryFn: () => getAffiliateUserData(affId!),
    enabled: !!affId,
  })
}
